<div class="login-wrapper">
  <div class="login-mid-container">
    <div class="right-side">
      <img
        src="../../../assets/images/495078-PHE69C-919.jpg"
        style="max-height: 100%; max-width: 100%"
      />
    </div>
    <div class="left-side">
      <!-- <h4>enable</h4> -->
      <img src="../../../assets/images/app-logo.png" />
      <h6>Lorem Ipsum is simply dummy text of the typesetting industry.</h6>
      <p>Welcome back, please login to your account</p>

      <div class="form">
        <div class="user-name input">
          <label>Company Name</label>

          <input
            type="text"
            pInputText
            [(ngModel)]="selectedRealm.name"
            placeholder="Enter Company Name"
          />
        </div>

        <button
          pButton
          type="button"
          label="Click to Login"
          class="login-btn"
          (click)="onClickLogin()"
        ></button>
      </div>
      <div class="left-bottom">
        <p>&copy; 2020 enable Licensing Server Version : 2.0.0</p>
      </div>
    </div>
  </div>
</div>
